import React, { useEffect, useState } from "react";
import { useAuthStore } from "../context/useAuthStore";
import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../services/firebase";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";
import {
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@mui/material";
import { formatTimestampOtp } from "../constants/Functions";

const SolicitudesNuevosSocios = () => {
  const { Worker }: any = useAuthStore();
  const { setTittleContenido }: any = useTittleContenidoStore();
  const [search, setSearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<string>("createdAt");
  const [solicitudes, setSolicitudes] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 9; // Número de solicitudes por página

  //Adquerir solicitudes de nuevos socios de la colección de Firestore solicitudesNewSocios
  const obtenerSolicitudes = async () => {
    setIsLoading(true);
    try {
      const solicitudesSnapshot = await getDocs(
        collection(db, "solicitudesNewSocios")
      );
      const solicitudesList = solicitudesSnapshot.docs.map((doc) => doc.data());
      console.log(solicitudesList);
      setSolicitudes(solicitudesList);
    } catch (error) {
      console.error("Error al obtener solicitudes:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    obtenerSolicitudes();
    setTittleContenido("Solicitudes Nuevos Socios");
  }, []);

  // Filtrar solicitudes por nombre o DNI
  const filteredSolicitudes = solicitudes.filter((solicitud) => {
    const nombres = solicitud.nombres?.toLowerCase() || "";
    const apellidos = solicitud.apellidos?.toLowerCase() || "";
    const dni = solicitud.dni?.toString() || "";
    return (
      nombres.includes(search.toLowerCase()) ||
      dni.includes(search) ||
      apellidos.includes(search.toLowerCase())
    );
  });

  // Función para manejar la ordenación
  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && orderDirection === "asc";
    setOrderDirection(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedSolicitudes = filteredSolicitudes
    .filter((solicitud) => {
      const createdAtString = solicitud.createdAt
        ? solicitud.createdAt.toDate().toLocaleDateString("es-ES")
        : ""; // Convierte a string o usa cadena vacía si es null
      return createdAtString.includes(search);
    })
    .slice()
    .sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue < bValue) return orderDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return orderDirection === "asc" ? 1 : -1;
      return 0;
    });

  // Calcular el número de páginas
  const pageCount = Math.ceil(filteredSolicitudes.length / itemsPerPage);

  // Obtener socios de la página actual
  const displayedSolicitudes = sortedSolicitudes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Cambiar la página
  const handlePageChange = (event: any, value: any) => {
    setCurrentPage(value);
  };

  //Atender la solicitud
  const atenderSolicitud = async (solicitud: any) => {
    setIsLoading(true);
    try {
      const solicitudRef = doc(db, "solicitudesNewSocios", solicitud.id);
      await updateDoc(solicitudRef, {
        estado: "Atendido",
        workerAtencionEmail: Worker.email,
        updateAt: new Date(),
      });

      obtenerSolicitudes();
    } catch (error) {
      console.error("Error al atender la solicitud:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <BackdropComponent enabled={isLoading} />}
      <div className="d-flex justify-content-center h-100 mb-5">
        <TextField
          label="Buscar por DNI, nombre o apellidos"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-25"
        />
        {/* Cantidad de solicitudes */}
        <h3 className="mt-3 text-secondary fw-bold ms-5">
          Cantidad de solicitudes: {filteredSolicitudes.length}
        </h3>
      </div>

      {/* Tabla de socios */}
      <div style={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                DNI
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Apellidos y Nombres
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Nro. Celular
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                <TableSortLabel
                  active={orderBy === "createdAt"}
                  direction={orderBy === "createdAt" ? orderDirection : "asc"}
                  onClick={() => handleRequestSort("createdAt")}
                >
                  Fecha de solicitud
                </TableSortLabel>
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Estado
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSolicitudes.map((solicitud) => (
              <TableRow key={solicitud.dni}>
                <TableCell style={{ textAlign: "center" }}>
                  {solicitud.dni}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  {solicitud.nombres} {solicitud.apellidos}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  {solicitud.nroTelefono}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  {formatTimestampOtp(solicitud.createdAt)}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  {solicitud.estado}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      atenderSolicitud(solicitud.dni);
                    }}
                  >
                    Marcar como Atendido
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Paginación */}
      <Stack spacing={2} alignItems="center" marginY={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </div>
  );
};

export default SolicitudesNuevosSocios;
